import React from 'react';
import {connect} from 'react-redux';

import LANGUAGES_CONTROLLER from '../../../controllers/languages';
import Logger, {LOG_LEVELS} from '../../../utils/logger';

const log = new Logger('MULTI_COMPANY_SELECTOR', LOG_LEVELS.DEBUG);

export class MultiCompanySelector extends React.Component {

  checkboxChangeHandlerFactory(fieldName) {
    return (event) => {
      log.debug('checkboxChangeHandlerFactory(%s): %s, ', fieldName, event);
      log.debug('checkboxChangeHandlerFactory(%s): oldValue: %s, newValue: %s  ', fieldName, this.props[fieldName], event.target.checked, event.target.value);
      let selection = {};
      let selectedCompanyIds = this.props.selectedCompanyIds || [];
      //Index is always getting -1, hence convert target value to number and get index
      let index = selectedCompanyIds.indexOf(event.target.value);
      if (index >= 0) {
        selectedCompanyIds.splice(index, 1);
      }
      else {
        selectedCompanyIds.push(event.target.value);
      }
      selection[fieldName] = selectedCompanyIds;
      this.props.selectionHandler(selection);
    }
  }

  selectAllHandlerFactory(fieldName, clearAll) {
    return () => {
      log.debug('selectAllHandlerFactory(%s): %s, ', fieldName);
      let selection = {};

      if (clearAll) {
        selection[fieldName] = [];
      }
      else {
        selection[fieldName] = this.props.companyList.reduce((accumulator, company) => {
          if (accumulator.indexOf(company.id) < 0) {
            accumulator.push(company.id);
          }
          return accumulator;
        }, []);
      }


      this.props.selectionHandler(selection);
    }
  }

  render() {
    log.debug('render(): ', this.props);
    //Default Company when only 1 company
    var checkCompanyId = false;
    if(this.props.companyList.length === 1 && this.props.selectedCompanyIds.length === 0)
    {
        checkCompanyId = true;
    }
    let selectedCompanyIds = this.props.selectedCompanyIds || [];
    return (
      <div>
        {
          this.props.companyList.map((company, key) => {
            const checked = (selectedCompanyIds.indexOf(company.id) >= 0 || selectedCompanyIds.indexOf(`${company.id}`) >= 0) || checkCompanyId;
            return (
              <div className="mb5 float-left full-width" key={key}>
                <input
                  className="mt10 checkbox"
                  onChange={this.checkboxChangeHandlerFactory(this.props.fieldName).bind(this)}
                  type="checkbox"
                  value={company.id}
                  checked={checked}/>
                <label className="mt10 checkbox">({company.code}) - {company.name}</label><br />
              </div>
            )
          })
        }
        <button className="secondary mt10" onClick={this.selectAllHandlerFactory(this.props.fieldName).bind(this)}>
          {LANGUAGES_CONTROLLER.format(this.props.languages, 'SelectAll')}
        </button>
        <button className="secondary mt10" onClick={this.selectAllHandlerFactory(this.props.fieldName, true).bind(this)}>
          {LANGUAGES_CONTROLLER.format(this.props.languages, 'ClearAll')}
        </button>
      </div>
    )
  }
}


function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  const defaultCompanyList = ( state.companies && state.companies.data ) ||[];

  return {
    languages: state.languages,
  };
}


// Wrap the component to inject state into it
export default connect(mapStateToProps)(MultiCompanySelector);